export interface LoginLayoutLoginState {
    username: string
    password: string
    error: string
    busy: boolean
    usernameInError: boolean
    passwordInError: boolean
    showPassword: boolean
}
export const initialLoginLayoutLoginState =
    (): LoginLayoutLoginState => ({
        username: '',
        password: '',
        error: '',
        busy: false,
        usernameInError: false,
        passwordInError: false,
        showPassword: false
    })
